import Select, {components} from 'react-select'
import {Button} from 'reactstrap'

import HelperIcon from "@src/components/helpers/HelperIcon"
import {trans} from '@utils'

const ReactSelectDropdownButton = (props) => {
  const {
    name, 
    value = null, 
    placeholder = trans('gen.reactSelect.placeholder'),
    width = 'auto',
    options = [],
    isLoading = false,
    target = null,
    onChange = () => {}
  } = props
  return (
    <Select
      name={name}
      value={value}
      options={options}
      classNamePrefix='select'
      className={'react-select-dropdown'}
      isLoading={isLoading}
      isClearable={false}
      isMulti={false}
      menuPortalTarget={target}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          width: 80,
          minHeight: 0
        }),
        valueContainer: (baseStyles, state) => ({
          ...baseStyles,
          padding: 0
        }),
        menu: (baseStyles, state) => ({
            ...baseStyles,
            width,
            minWidth: 200
        }),
        option: (baseStyles, state) => ({
            ...baseStyles,
            padding: '0.50rem',
            textWrap: 'nowrap'
        })
      }}
      components={{
        Input: (props) => {
          const {value, onChange, ...rest} = props
          return (
            <Button type='button' color={'link'} size={'sm'} disabled={isLoading} className={'react-select-dropdown-button w-100 text-nowrap p-25'}>
              {placeholder}
              <components.Input {...rest}/>
            </Button>
          )
        },
        Option: (props) => {
          return (
            <components.Option {...props}>
              <div className='d-flex align-items-center'>
                {props.children}
                {props.data.tooltip && <HelperIcon triggerTooltipOnClick={true} text={props.data.tooltip}/>}
              </div>
            </components.Option>
          )
        },
        LoadingIndicator: () => null, 
        DropdownIndicator: () => null,
        ClearIndicator: () => null,
        IndicatorSeparator: () => null,
        Placeholder: () => null
      }}
      onChange={onChange}
    />
  )
}

export default ReactSelectDropdownButton